exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal[data-v-44b191c6]{position:fixed;top:0;left:0;bottom:0;right:0;background:rgba(0,0,0,.5);z-index:3;width:100%}.modal-window[data-v-44b191c6]{position:absolute;top:50%;left:50%;transition:.5s;width:40%;min-width:400px;max-width:600px;background:#fff;box-shadow:0 0 10px rgba(0,0,0,.5);transform:translate(-50%,-50%);padding:1em;color:#000;text-align:center}.actions button[data-v-44b191c6]{font-size:inherit;margin:4px;border:none;padding:6px 8px;cursor:pointer}.actions .confirm[data-v-44b191c6]{background:#008b8b;color:#fff}.actions .cancel[data-v-44b191c6]{background:darkred;color:#fff}.content[data-v-44b191c6]{text-align:left}.content button[data-v-44b191c6]{border:none;background:none;color:#5e74bc}.content button[data-v-44b191c6]:hover{color:#d1b168}button[data-v-44b191c6]{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-44b191c6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GatewayError.vue
// module id = 73
// module chunks = 0